export function anonymiseCandidateName(firstName = "", lastName = "") {
  return `${firstName.replace(/\B[a-z]/g, "*")} ${lastName.replace(
    /\B[a-z]/g,
    "*"
  )}`;
}
